import type { PlatformAssetMeta } from '@inflip/contracts/admin';

import { api } from './api-client';

/**
 * 어드민 탭 아이콘 = 홈페이지 설정의 파비콘. 부팅 시 버전 없는 URL 로 걸고(없으면 404 → 브라우저 기본),
 * 홈페이지 설정에서 올리거나 지우면 즉시 갱신한다.
 */
export function applyAdminFavicon(meta?: PlatformAssetMeta | null): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  if (meta === null) {
    link.remove();
    return;
  }
  link.href = api.platformAssetUrl('favicon', meta);
  if (meta) link.type = meta.mimeType;
}
